<template>
  <div class="pages">
    <div class="pagesContent">
      <top-nav :leftData='leftData' :activeNav='$route.params.pathId'></top-nav>
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{contentTitle}}</div>
          <div class="engName">{{englishName}}</div>
        </div>
        <div class="compContent">
          <abilityNew v-if="$route.params.pathId === 'abilityNew'"></abilityNew>
          <abilityTeam v-if="$route.params.pathId === 'abilityTeam'"></abilityTeam>
          <abilityBroker v-if="$route.params.pathId === 'abilityBroker'"></abilityBroker>
          <abilitySpark v-if="$route.params.pathId === 'abilitySpark'"></abilitySpark>
          <abilitySwan v-if="$route.params.pathId === 'abilitySwan'"></abilitySwan>
          <!-- <abilityRecruit v-if="$route.params.pathId === 'abilityRecruit'"></abilityRecruit> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import topNav from '@/components/topNav'
  import abilityNew from '@/components/abilityNew'
  import abilityTeam from '@/components/abilityTeam'
  import abilityBroker from '@/components/abilityBroker'
  import abilitySpark from '@/components/abilitySpark'
  import abilitySwan from '@/components/abilitySwan'
  // import abilityRecruit from '@/components/abilityRecruit'
  export default {
    name: 'about',
    components: {
      topNav,
      abilityNew,
      abilityTeam,
      abilityBroker,
      abilitySpark,
      abilitySwan,
      // abilityRecruit
    },
    data() {
      return {
        leftData: {
          title: '人才招聘',
          navs: [{
            name: 'abilityNew',
            text: '代理人新模式',
            fatherPath: 'ability',
            english: 'NEW MODEL OF ECONOMIC MAN',
            subBa: require('../assets/images/subBanner15.png')
          },
          {
            name: 'abilityTeam',
            text: '团队介绍',
            fatherPath: 'ability',
            english: 'TEAM INTRODUCTION',
            subBa: require('../assets/images/subBanner16.png')
          },
          {
            name: 'abilityBroker',
            text: '典范介绍',
            fatherPath: 'ability',
            english: 'BROKER INTRODUCTION',
            subBa: require('../assets/images/subBanner17.png')
          },
          {
            name: 'abilitySpark',
            text: '星火计划',
            fatherPath: 'ability',
            english: 'SPARK PLAN',
            subBa: require('../assets/images/subBanner18.png')
          },
          {
            name: 'abilitySwan',
            text: '鸿鹄计划',
            fatherPath: 'ability',
            english: 'SWAN PLAN',
            subBa: require('../assets/images/subBanner19.png')
          },
          // {
          //   name: 'abilityRecruit',
          //   text: '招贤纳士',
          //   fatherPath: 'ability',
          //   english: 'JOIN US',
          //   subBa: require('../assets/images/subBanner20.png')
          // }
        ]
        }
      }
    },
    computed: {
      contentTitle(){
        return this.leftData.navs.find(item=>item.name === this.$route.params.pathId).text
      },
      englishName(){
        return this.leftData.navs.find(item=>item.name === this.$route.params.pathId).english
      }
    },
    created() {
    },
    mounted() {},
    methods: {

    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .compContent{

  }
</style>